export default {
  state: {
    formData: {
      id: 0,
      type: '',
      name: '',
      mz_id: 0,
      company: '',
      client_id: 0,
      hasTransfer: 0,
      edit_date: '',
      greeting: '',
      password: '',
      customFields: [],
      deletedFields: [],
      results: [],
      deletedResults: [],
      displayLastCall: 0,
    }
  },
  mutations: {
    addCustomField (state, payload) {
      state.formData.customFields.push(payload)
    },
    setFormData (state, payload) {
      state.formData = payload
    },
    updateLastCall(state, enableDisplayLastCall) {
      state.formData.displayLastCall = enableDisplayLastCall;
    },
  },
  actions: {
    addCustomField ({commit}, payload) {
      commit('addCustomField', payload)
    },
    setFormData ({commit}, payload) {
      commit('setFormData', payload)
    },
    updateLastCall({commit}, enableDisplayLastCall) {
      commit('updateLastCall', enableDisplayLastCall);
    },
  },
  getters: {
    formData (state) {
      return state.formData
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/formInputs.js